import { render, staticRenderFns } from "./TakeOverModal.vue?vue&type=template&id=234fb090&"
import script from "./TakeOverModal.vue?vue&type=script&lang=js&"
export * from "./TakeOverModal.vue?vue&type=script&lang=js&"
import style0 from "./TakeOverModal.vue?vue&type=style&index=0&id=234fb090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports